import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import a from '../../../../../redux/actions';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';
import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';
import types from '../../../../../types';
import makeInputValue from '../../../../../lib/makeInputValue';

const dayOptions = range(1, 11).map(value => ({ value, display: value.toString() }));

const vehicleTradeInOptions = (vehicles, t) => vehicles
  .filter(vehicle => !vehicle.isElectric)
  .map(vehicle => ({ value: vehicle.index, display: t('Vehicle {{index}}', vehicle) }));

const TelecommuteToWork = ({
  t,
  widgetSource,
  isMetric,
  vehicles,
  telecommuteTradeInVehicle,
  updateTradeInVehicle,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('I will telecommute to work')}
        <InlineSelect
          options={dayOptions}
          apiKey={'input_takeaction_telecommute_to_work_days'}
        />
        {t('day(s) per month instead of driving')}
        <InlineSelect
          ariaLabel={t('vehicle')}
          options={vehicleTradeInOptions(vehicles, t)}
          inputValue={makeInputValue(telecommuteTradeInVehicle.index, 1)}
          onChange={value => updateTradeInVehicle('telecommute_to_work', value)}
        />
        {t('which has a fuel economy of {{efficiencyDisplay}} {{fuelEfficiencyUnit}}.', telecommuteTradeInVehicle)}
      </p>
      <p>
        {t('The one way distance to work is')}
        <InlineInput
          apiKey="input_takeaction_telecommute_to_work_miles"
          maxLength={3}
        />
        {t('{{distanceUnit}}. I will avoid paying', { distanceUnit: isMetric ? t('km', { ns: 'units' }) : t('mi', { ns: 'units' }) })}
        <InlineInput
          currency
          maxLength={5}
          apiKey="input_takeaction_telecommute_to_work_parking"
        />
        {t('each month for parking')}.
      </p>
      <p>
        {t('I will save')}
        <InlineInput
          maxLength={3}
          apiKey="input_takeaction_telecommute_to_work_times"
        />
        {t('hours a month by staying home. My travel-free time is worth')}
        <InlineInput
          currency
          maxLength={7}
          apiKey="input_takeaction_telecommute_to_work_worth"
        />
        {t('per hour to me')}.
      </p>
    </div>
    <div className="action-details__facts">
      {t('Not every job is suited for telecommuting, but if you can work from home the environmental and quality-of-life perks are quite compelling!')}
    </div>
    {widgetSource !== 'ontario' &&
      <div className="action-details__links">
        <a
          href="http://www.coolcalifornia.org/funding-wizard#search/water+heater//false/none/false/1/12"
          target="_blank"
          rel="noopener noreferrer"
        >{t('Find rebates and incentives for this action')}</a>
      </div>
    }
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('Price of gasoline:')}
          <InlineInput
            currency
            apiKey="input_takeaction_assumption_price_of_gasoline"
          />
          {t('per {{volumeUnit}}', { volumeUnit: isMetric ? t('L', { ns: 'units' }) : t('gal', { ns: 'units' }) })}
        </li>
      </ul>
    </div>
  </div>
);

TelecommuteToWork.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
  telecommuteTradeInVehicle: types.Vehicle.isRequired,
  vehicles: types.Vehicles.isRequired,
  isMetric: PropTypes.bool.isRequired,
  updateTradeInVehicle: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'vehicles',
  'isMetric',
  'telecommuteTradeInVehicle',
  'widgetSource',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'updateTradeInVehicle',
  ]),
  dispatch,
);

export default wrap(
  withT('telecommuteToWork'),
  connect(mapStateToProps, mapDispatchToProps)(TelecommuteToWork),
);
